<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15TehZy/tc-custom/9780226788449.jpg?1734282768991" alt="This image is the cover for the book Electrodynamics, Chicago Lectures in Physics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Electrodynamics, Chicago Lectures in Physics
      </h1>
      <p class="bookDescription body article font2">
        <p>Practically all of modern physics deals with fields—functions of space (or spacetime) that give the value of a certain quantity, such as the temperature, in terms of its location within a prescribed volume. Electrodynamics is a comprehensive study of the field produced by (and interacting with) charged particles, which in practice means almost all matter.<br/><br/> Fulvio Melia's <i>Electrodynamics</i> offers a concise, compact, yet complete treatment of this important branch of physics. Unlike most of the standard texts, <i>Electrodynamics</i> neither assumes familiarity with basic concepts nor ends before reaching advanced theoretical principles. Instead this book takes a continuous approach, leading the reader from fundamental physical principles through to a relativistic Lagrangian formalism that overlaps with the field theoretic techniques used in other branches of advanced physics. Avoiding unnecessary technical details and calculations, <i>Electrodynamics</i> will serve both as a useful supplemental text for graduate and advanced undergraduate students and as a helpful overview for physicists who specialize in other fields.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fulvio Melia
      </h2>
      
      <p class="authorDescription body article"><B>Fulvio Melia</B> is professor of physics and astronomy at the University of Arizona. He is coeditor of <I>The Central Parsecs of the Galaxy</I> and scientific editor of <I>The Astrophysical Journal</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cdfcc4e8